/**
 * Echo-Schutz des Wach-Worts (20.10.2026): Die App will wissen, ob der Text, den Vespera gerade spricht, ihren
 * Namen nennt. Gemeldet wird NUR ein Bool (Plugin-Methode `wachwortWiedergabeName`), nie der Text; nichts wird
 * protokolliert. Ohne natives Plugin oder in einer älteren App passiert nichts.
 */
import { korrigiereVespera } from "../../shared/vespera-schreibweise.js";
import { wachwortWiedergabeName } from "./native-voice.js";

/** Nennt der gesprochene Text „Vespera“ — auch als Verhörung (korrigiereVespera)? */
export function nenntNamen(text: string): boolean {
  try {
    return /vespera/i.test(text) || /vespera/i.test(korrigiereVespera(text));
  } catch {
    return false;
  }
}

/** Beginn eines vorgelesenen Stücks. */
export function meldeWiedergabeName(text: string): void {
  void wachwortWiedergabeName(nenntNamen(text)).catch(() => undefined);
}

/** Ende der Antwort: zurücksetzen. */
export function meldeWiedergabeEnde(): void {
  void wachwortWiedergabeName(false).catch(() => undefined);
}
